import { QueryClient } from '@tanstack/react-query';
import { createRouter, type AnyRouteMatch, type ParsedLocation } from '@tanstack/react-router';

import { getAuthState } from './auth';
import { routeTree } from './routeTree.gen';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
    },
  },
});

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  context: {
    queryClient,
    auth: getAuthState(),
    // Closures over `router` rather than values captured at creation time —
    // `router` doesn't exist yet on this line, and the permissions guard
    // needs the LIVE resolved location / matcher on every navigation, not a
    // snapshot from boot. `resolvedLocation` is undefined on a fresh load and
    // stays undefined through a denied navigation (it never resolves), so it
    // can't be clobbered by the page the guard is in the middle of rejecting.
    getPreviousLocation: (): ParsedLocation | undefined => router.state.resolvedLocation,
    matchRoutes: (pathname: string): AnyRouteMatch[] => router.matchRoutes(pathname),
  },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
